import { useContext } from "react";
import { CreateActionContext } from "./CreateActionContext";

function useInitialize() {
  const { setElement, setSelectedLang, setShowModal, setBackendFormErrors } = useContext(CreateActionContext);
  return (formDefaultValues: any) => {
    setBackendFormErrors({});
    setElement(formDefaultValues);
    setSelectedLang("es");
    setShowModal(true);
  };
}

export default useInitialize;
